import { createContext, ReactNode, useContext } from 'react';

import type { ReviewListTabContentProps } from '../types';

/** @public */
interface PathRecord {
  auth: {
    login: string;
  };
  review: {
    list: (product_id: string, shop_main_domain?: string) => string;
    best_review_list?: (product_id: string, review_id?: string, attachment_position?: number) => string;
  };
}

/** @public */
export interface PdpConfigContextValue {
  isZigzagApp: boolean;
  ZIGZAGUUID?: string;
  isGlobal?: boolean;
  isProductPreview?: boolean;
  catalogProductId?: string;
  funnelType?: string;
  from?: 'recommendations' | 'cart' | 'ordersheet' | 'similar_products' | 'tf_invite_challenge';
  path: PathRecord;
  isSelectedPdpApp?: boolean;
  isSelectedPdpWeb?: boolean;
  source?: string;
  ReviewListTabContent?: React.FC<React.PropsWithChildren<ReviewListTabContentProps>>;
  isGroupOrderBridgeTest?: boolean;
}

/** @public */
export const ConfigContext = createContext<PdpConfigContextValue>({
  isZigzagApp: false,
  ZIGZAGUUID: '',
  isGlobal: false,
  isProductPreview: false,
  source: '',
  path: {
    auth: { login: '' },
    review: {
      list: () => '',
      best_review_list: () => '',
    },
  },
});

/** @public */
export const usePdpConfig = () => useContext(ConfigContext);

/** @public */
export interface PdpConfigProviderProps extends PdpConfigContextValue {
  children: ReactNode;
}

/** @public */
export function PdpConfigProvider({ children, ...value }: PdpConfigProviderProps) {
  return <ConfigContext.Provider children={children} value={value} />;
}
